import script from "./IncomeBusinessHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeBusinessHandler.vue?vue&type=script&setup=true&lang=js"

import "./IncomeBusinessHandler.vue?vue&type=style&index=0&id=052d8651&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052d8651"]])

export default __exports__